import React, { ChangeEventHandler } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { ISelect } from '../../../../shared/types/shared';

type Props = {
    data?: ISelect[];
    label: string;
    name: string;
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: string | undefined;
    defineValue?: string | undefined;
    touched?: boolean;
    errors?: string;
    disabled?: boolean;
    onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onBlur?:
        | React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
        | undefined;
    emptyOptionLabel?: string;
};

const fieldSelectSx = {
    '& label.Mui-focused': {
        color: 'primary.main',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'primary.main',
    },
    '& .MuiFilledInput-underline:after': {
        borderBottomColor: 'primary.main',
    },
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: 'primary.main',
        },
    },
};

export const OrbitFieldSelect = ({
    data,
    label,
    name,
    size,
    margin,
    required,
    touched,
    errors,
    value,
    defineValue,
    disabled,
    onChange,
    onBlur,
    emptyOptionLabel = 'Seleccionar...',
}: Props) => {
    const hasValue = Boolean(value);

    return (
        <TextField
            id="select-field"
            select
            fullWidth
            label={label}
            name={name}
            value={hasValue ? value : ''}
            required={required}
            margin={margin}
            disabled={disabled}
            onChange={onChange}
            size={size || 'small'}
            helperText={touched ? errors : ''}
            error={touched && Boolean(errors)}
            onBlur={onBlur}
            InputLabelProps={{ shrink: true }}
            SelectProps={{
                displayEmpty: true,
                renderValue: !hasValue
                    ? () => (
                        <span style={{ color: 'rgba(0, 0, 0, 0.6)' }}>
                            {emptyOptionLabel}
                        </span>
                    )
                    : undefined,
            }}
            sx={fieldSelectSx}
        >
            <MenuItem value="">&nbsp;</MenuItem>
            {data?.map((option) => (
                <MenuItem
                    key={option.id}
                    value={defineValue === 'value' ? option.name : option.id}
                >
                    {option.name}
                </MenuItem>
            ))}
        </TextField>
    );
};
